// @ts-nocheck
export const REPORTING_SET_TABLE_STATS_BY_STEP = 'REPORTING_SET_TABLE_STATS_BY_STEP';
export const REPORTING_SET_SELECTED_CAMPAIGNS = 'REPORTING_SET_SELECTED_CAMPAIGNS';
export const REPORTING_SET_CHANGE_LOG_DATA = 'REPORTING_SET_CHANGE_LOG_DATA';
export const REPORTING_SET_TOTAL_AVG_MODE = 'REPORTING_SET_TOTAL_AVG_MODE';
export const REPORTING_SET_TOTAL_AVG_MODES = 'REPORTING_SET_TOTAL_AVG_MODES';
export const REPORTING_TRIGGER = 'REPORTING_TRIGGER';
export const REPORTING_SET_FOOTFALL_ATTRIBUTION_STATS = 'REPORTING_SET_FOOTFALL_ATTRIBUTION_STATS';
export const REPORTING_TOGGLE_MAP_LOADING = 'REPORTING_TOGGLE_MAP_LOADING';
export const REPORTING_SET_HEATMAP_DATA = 'REPORTING_SET_HEATMAP_DATA';
export const REPORTING_SET_CAMPAIGN_EVENTS = 'REPORTING_SET_CAMPAIGN_EVENTS';
export const REPORTING_SET_INDIVIDUAL_EVENTS = 'REPORTING_SET_INDIVIDUAL_EVENTS';
export const REPORTING_SET_EVENTS_BY_GEOHASH = 'REPORTING_SET_EVENTS_BY_GEOHASH';
export const REPORTING_RESET_MAP_DATA = 'REPORTING_RESET_MAP_DATA';
export const REPORTING_SET_MAP_EVENTS = 'REPORTING_SET_MAP_EVENTS';
export const REPORTING_SET_MAP_SELECTED_EVENTS = 'REPORTING_SET_MAP_SELECTED_EVENTS';
export const REPORTING_SET_STATIC_MODE = 'REPORTING_SET_STATIC_MODE';
export const REPORTING_FETCH_CAMPAIGN_SCREENS = 'REPORTING_FETCH_CAMPAIGN_SCREENS';
export const REPORTING_FETCH_SHARED_REPORTS = 'REPORTING_FETCH_SHARED_REPORTS';
export const REPORTING_SET_CAMPAIGNS_SCREENS = 'REPORTING_SET_CAMPAIGNS_SCREENS';
export const REPORTING_SET_SHARED_REPORTS = 'REPORTING_SET_SHARED_REPORTS';
export const REPORTING_PROGRESS_SET_KPI_STATS = 'REPORTING_PROGRESS_SET_KPI_STATS';
export const REPORTING_PROGRESS_RESET_KPI_STATS = 'REPORTING_PROGRESS_RESET_KPI_STATS';
export const REPORTING_PROGRESS_SET_KPI_STATS_STATUS = 'REPORTING_PROGRESS_SET_KPI_STATS_STATUS';
export const REPORTING_PROGRESS_SET_STATS = 'REPORTING_PROGRESS_SET_STATS';
export const REPORTING_INSIGHTS_SET_GROUP_BY_CONFIG = 'REPORTING_INSIGHTS_SET_GROUP_BY_CONFIG';
export const REPORTING_INSIGHTS_SET_METRICS_CONFIG = 'REPORTING_INSIGHTS_SET_METRICS_CONFIG';
export const REPORTING_INSIGHTS_SET_RAW_DATA = 'REPORTING_INSIGHTS_SET_RAW_DATA';
export const REPORTING_ADVANCED_FILTERS_SET_ENABLED = 'REPORTING_ADVANCED_FILTERS_SET_ENABLED';
export const REPORTING_SET_COUNTRIES_WITH_EVENTS = 'REPORTING_SET_COUNTRIES_WITH_EVENTS';
export const REPORTING_SET_DEFAULT_MAP_BOUNDING_BOX = 'REPORTING_SET_DEFAULT_MAP_BOUNDING_BOX';
export const REPORTING_RESET_SECTIONS_STATS = 'REPORTING_RESET_SECTIONS_STATS';
export const REPORTING_INSIGHTS_SET_STATS = 'REPORTING_INSIGHTS_SET_STATS';
export const REPORTING_INSIGHTS_RESET_STATS = 'REPORTING_INSIGHTS_RESET_STATS';
export const REPORTING_PROGRESS_RESET_STATS = 'REPORTING_PROGRESS_RESET_STATS';
export const REPORTING_TOGGLE_CAMPAIGN_LINES_INFO = 'REPORTING_TOGGLE_CAMPAIGN_LINES_INFO';
export const REPORTING_RESET_STORE = 'REPORTING_RESET_STORE';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_STATS = 'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_STATS';
export const REPORTING_SET_AGGREGATED_STATS = 'REPORTING_SET_AGGREGATED_STATS';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_EVENT_FAMILIES = 'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_EVENT_FAMILIES';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_CAMPAIGN_STATUS =
  'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_CAMPAIGN_STATUS';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_SEARCH_TEXT = 'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_SEARCH_TEXT';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ONLY_TOP_CAMPAIGNS =
  'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ONLY_TOP_CAMPAIGNS';
export const REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ANALYTICAL_VIEW =
  'REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ANALYTICAL_VIEW';
export const REPORTING_DOWNLOAD_SUMMARY_DATA = 'REPORTING_DOWNLOAD_SUMMARY_DATA';
export const REPORTING_DOWNLOAD_INSIGHTS_DATA = 'REPORTING_DOWNLOAD_INSIGHTS_DATA';
export const REPORTING_SET_DOWNLOAD_SUMMARY_DATA = 'REPORTING_SET_DOWNLOAD_SUMMARY_DATA';
export const REPORTING_SET_DOWNLOAD_INSIGHTS_DATA = 'REPORTING_SET_DOWNLOAD_INSIGHTS_DATA';
export const REPORTING_SET_SECTIONS_VISIBILITY = 'REPORTING_SET_SECTIONS_VISIBILITY';
export const SET_REPORTING_CARTOGRAPHY_FILTER_MAP = 'SET_REPORTING_CARTOGRAPHY_FILTER_MAP';
export const REPORTING_MAP_CHANGE_MAP_VIEW = 'REPORTING_MAP_CHANGE_MAP_VIEW';
export const RELOAD_REPORTING_CARTOGRAPHY_FILTER_MAP = 'RELOAD_REPORTING_CARTOGRAPHY_FILTER_MAP';
export const REPORTING_CHANGE_CONTEXTUAL_DISCOVERY_REPORT_STATUS =
  'REPORTING_CHANGE_CONTEXTUAL_DISCOVERY_REPORT_STATUS';
export const REPORTING_CHANGE_COVERAGE_STUDY_REPORT_STATUS = 'REPORTING_CHANGE_COVERAGE_STUDY_REPORT_STATUS';
export const REPORTING_RESET_BEFORE_REFRESH = 'REPORTING_RESET_BEFORE_REFRESH';
export const REPORTING_CHANGE_GEOLOOKALIKE_STATUS = 'REPORTING_CHANGE_GEOLOOKALIKE_STATUS';
export const REPORTING_CHANGE_PDF_REPORT_STATUS = 'REPORTING_CHANGE_PDF_REPORT_STATUS';
export const REPORTING_CLEAN_PDF_REPORT_STATUS_BY_KEY = 'REPORTING_CLEAN_PDF_REPORT_STATUS_BY_KEY';
export const REPORTING_SET_STATS_GROUPS = 'REPORTING_SET_STATS_GROUPS';
export const REPORTING_PROGRESS_SET_METRIC_AND_KPI = 'REPORTING_PROGRESS_SET_METRIC_AND_KPI';
export const REPORTING_PROGRESS_SET_GRAPH_CONFIG = 'REPORTING_PROGRESS_SET_GRAPH_CONFIG';
export const REPORTING_SET_CARTOGRAPHY = 'REPORTING_SET_CARTOGRAPHY';
export const REPORTING_SET_CARTOGRAPHY_MAP_CONFIG = 'REPORTING_SET_CARTOGRAPHY_MAP_CONFIG';
export const REPORTING_SET_CUSTOM_EVENTS = 'REPORTING_SET_CUSTOM_EVENTS';

export const reportingResetSectionsStats = () => {
  return { type: REPORTING_RESET_SECTIONS_STATS };
};

export const reportingSetCountriesWithEvents = countriesWithEvents => {
  return {
    data: { countriesWithEvents },
    type: REPORTING_SET_COUNTRIES_WITH_EVENTS
  };
};

export const reportingSetDefaultMapBoundingBox = defaultBoundingBox => {
  return {
    data: { defaultBoundingBox },
    type: REPORTING_SET_DEFAULT_MAP_BOUNDING_BOX
  };
};

export const reportingSetKpiStatsStatus = (groupBy, status) => {
  return {
    data: {
      groupBy,
      status
    },
    type: REPORTING_PROGRESS_SET_KPI_STATS_STATUS
  };
};

export const reportingSetKpiStats = stats => {
  return {
    data: stats,
    type: REPORTING_PROGRESS_SET_KPI_STATS
  };
};

export const reportingResetKpiStats = stats => {
  return {
    data: stats,
    type: REPORTING_PROGRESS_RESET_KPI_STATS
  };
};

export const reportingSetTableStatsByStep = tableStatsByStep => {
  return {
    data: { tableStatsByStep },
    type: REPORTING_SET_TABLE_STATS_BY_STEP
  };
};

export const reportingSetSelectedCampaigns = selectedCampaigns => {
  return {
    data: { selectedCampaigns },
    type: REPORTING_SET_SELECTED_CAMPAIGNS
  };
};

export const reportingSetChangeLogData = changeLogData => {
  return {
    data: { changeLogData },
    type: REPORTING_SET_CHANGE_LOG_DATA
  };
};

export const reportingSetTotalAvgMode = (type, mode) => {
  return {
    data: {
      mode,
      type
    },
    type: REPORTING_SET_TOTAL_AVG_MODE
  };
};

export const reportingSetTotalAvgModes = totalAvgModes => {
  return {
    data: { totalAvgModes },
    type: REPORTING_SET_TOTAL_AVG_MODES
  };
};

export const reportingTrigger = (trigger, params = {}) => {
  return {
    data: {
      params,
      trigger
    },
    type: REPORTING_TRIGGER
  };
};

export const reportingSetFootfallAttributionStats = footfallAttributionStats => {
  return {
    data: { footfallAttributionStats },
    type: REPORTING_SET_FOOTFALL_ATTRIBUTION_STATS
  };
};

export const reportingToggleMapLoading = (mapId, toggle) => {
  return {
    data: {
      mapId,
      toggle
    },
    type: REPORTING_TOGGLE_MAP_LOADING
  };
};

export const reportingSetHeatmapData = (mapId, heatmapData) => {
  return {
    data: {
      heatmapData,
      mapId
    },
    type: REPORTING_SET_HEATMAP_DATA
  };
};

export const reportingSetCampaignEvents = campaignEvents => {
  return {
    data: { campaignEvents },
    type: REPORTING_SET_CAMPAIGN_EVENTS
  };
};

export const reportingSetIndividualEvents = (mapId, individualEvents) => {
  return {
    data: {
      individualEvents,
      mapId
    },
    type: REPORTING_SET_INDIVIDUAL_EVENTS
  };
};

export const reportingSetEventsByGeoH = (mapId, eventsByGeoH) => {
  return {
    data: {
      eventsByGeoH,
      mapId
    },
    type: REPORTING_SET_EVENTS_BY_GEOHASH
  };
};

export const reportingResetMapData = mapId => {
  return {
    data: { mapId },
    type: REPORTING_RESET_MAP_DATA
  };
};

export const reportingMapChangeMapView = (section, mapId) => {
  return {
    data: {
      mapId,
      section
    },
    type: REPORTING_MAP_CHANGE_MAP_VIEW
  };
};

export const reportingSetMapEvents = mapEvents => {
  return {
    data: { mapEvents },
    type: REPORTING_SET_MAP_EVENTS
  };
};

export const reportingSetMapSelectedEvents = mapSelectedEvents => {
  return {
    data: { mapSelectedEvents },
    type: REPORTING_SET_MAP_SELECTED_EVENTS
  };
};

export const reportingSetStaticMode = staticMode => {
  return {
    data: { staticMode },
    type: REPORTING_SET_STATIC_MODE
  };
};

export const reportingFetchCampaignScreens = campaignIds => {
  return {
    data: { campaignIds },
    type: REPORTING_FETCH_CAMPAIGN_SCREENS
  };
};

export const reportingFetchSharedReports = (campaignIds, type) => {
  return {
    data: { campaignIds, type },
    type: REPORTING_FETCH_SHARED_REPORTS
  };
};

export const reportingSetCampaignsScreens = screens => {
  return {
    data: { screens },
    type: REPORTING_SET_CAMPAIGNS_SCREENS
  };
};

export const reportingSetSharedReports = sharedReports => {
  return {
    data: { sharedReports },
    type: REPORTING_SET_SHARED_REPORTS
  };
};

export const reportingInsightsSetGroupByConfig = ({ insightGroupByConfig, insightId }) => {
  return {
    data: {
      insightGroupByConfig,
      insightId
    },
    type: REPORTING_INSIGHTS_SET_GROUP_BY_CONFIG
  };
};

export const reportingInsightsSetMetricsConfig = ({ metricsConfig }) => {
  return {
    data: {
      metricsConfig
    },
    type: REPORTING_INSIGHTS_SET_METRICS_CONFIG
  };
};

export const reportingInsightsSetRawData = ({ section, state }) => {
  return {
    data: {
      section,
      state
    },
    type: REPORTING_INSIGHTS_SET_RAW_DATA
  };
};

export const reportingAdvancedFiltersSetEnabled = enabled => {
  return {
    data: { enabled },
    type: REPORTING_ADVANCED_FILTERS_SET_ENABLED
  };
};

export const reportingInsightsSetStats = (insightsId, stats) => {
  return {
    data: {
      insightsId,
      stats
    },
    type: REPORTING_INSIGHTS_SET_STATS
  };
};

export const reportingInsightsResetStats = () => {
  return { type: REPORTING_INSIGHTS_RESET_STATS };
};

export const reportingProgressResetStats = () => {
  return { type: REPORTING_PROGRESS_RESET_STATS };
};

export const reportingProgressSetStats = (chartType, stats) => {
  return {
    data: {
      chartType,
      stats
    },
    type: REPORTING_PROGRESS_SET_STATS
  };
};

export const reportingToggleCampaignLinesInfo = option => {
  return {
    data: { option },
    type: REPORTING_TOGGLE_CAMPAIGN_LINES_INFO
  };
};

export const reportingResetStore = () => {
  return { type: REPORTING_RESET_STORE };
};

export const reportingSetCampaignItemDetailsStats = (status, result) => {
  return {
    data: {
      result,
      status
    },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_STATS
  };
};

export const reportingSetCampaignItemDetailsEventFamilies = eventFamilies => {
  return {
    data: { eventFamilies },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_EVENT_FAMILIES
  };
};

export const reportingSetCampaignItemDetailsCampaignStatus = campaignStatus => {
  return {
    data: { campaignStatus },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_CAMPAIGN_STATUS
  };
};

export const reportingSetCampaignItemDetailsSearchText = searchText => {
  return {
    data: { searchText },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_SEARCH_TEXT
  };
};

export const reportingSetCampaignItemDetailsOnlyTopCampaigns = enabled => {
  return {
    data: { enabled },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ONLY_TOP_CAMPAIGNS
  };
};

export const reportingSetCampaignItemDetailsAnalyticalView = enabled => {
  return {
    data: { enabled },
    type: REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ANALYTICAL_VIEW
  };
};

export const reportingSetAggregatedStats = (stats, section) => {
  return {
    data: {
      section,
      stats
    },
    type: REPORTING_SET_AGGREGATED_STATS
  };
}; // todo can't be deleted, still some selector using this

export const reportingDownloadSummaryData = (fileFormat, fileColumns, sheetHeadersTitle, token) => {
  return {
    data: {
      fileColumns,
      fileFormat,
      sheetHeadersTitle,
      token
    },
    type: REPORTING_DOWNLOAD_SUMMARY_DATA
  };
};

export const reportingDownloadInsightsData = (insights, params, token, section) => {
  return {
    data: {
      insights,
      params,
      section,
      token
    },
    type: REPORTING_DOWNLOAD_INSIGHTS_DATA
  };
};

export const reportingSetDownloadSummaryData = (status, format, result) => {
  return {
    data: {
      format,
      result,
      status
    },
    type: REPORTING_SET_DOWNLOAD_SUMMARY_DATA
  };
};

export const reportingSetDownloadInsightsData = (status, result) => {
  return {
    data: {
      result,
      status
    },
    type: REPORTING_SET_DOWNLOAD_INSIGHTS_DATA
  };
};

export const reportingSetSectionsVisibility = sectionsVisibility => {
  return {
    data: { sectionsVisibility },
    type: REPORTING_SET_SECTIONS_VISIBILITY
  };
};

export const setReportingCartographyFilterMap = mapId => {
  return {
    data: { id: mapId },
    type: SET_REPORTING_CARTOGRAPHY_FILTER_MAP
  };
};

export const reportingResetBeforeRefresh = () => {
  return { type: REPORTING_RESET_BEFORE_REFRESH };
};

export const reloadReportingCartographyFilterMap = mapId => {
  return {
    data: { id: mapId },
    type: RELOAD_REPORTING_CARTOGRAPHY_FILTER_MAP
  };
};

export const setContextualDiscoveryReportStatusChanged = data => {
  return {
    data: {
      name: data?.name,
      reportId: data?.reportId,
      reportUrl: data?.reportUrl,
      status: data?.status
    },
    type: REPORTING_CHANGE_CONTEXTUAL_DISCOVERY_REPORT_STATUS
  };
};

export const setCoverageStudyReportStatusChanged = data => {
  return {
    data: {
      name: data?.name,
      reportId: data?.reportId,
      reportUrl: data?.reportUrl,
      status: data?.status
    },
    type: REPORTING_CHANGE_COVERAGE_STUDY_REPORT_STATUS
  };
};

export const setGeoLookALikeStatusChanged = data => {
  return {
    data: {
      fileUrl: data?.fileUrl,
      name: data?.name,
      reportId: data?.reportId,
      status: data?.status
    },
    type: REPORTING_CHANGE_GEOLOOKALIKE_STATUS
  };
};

export const setPdfStatusChanged = data => {
  return {
    data,
    type: REPORTING_CHANGE_PDF_REPORT_STATUS
  };
};

export const cleanPdfStatusByKey = data => {
  return {
    data,
    type: REPORTING_CLEAN_PDF_REPORT_STATUS_BY_KEY
  };
};

export const reportingSetStatsGroups = (tableType, groups) => {
  return {
    data: {
      groups,
      tableType
    },
    type: REPORTING_SET_STATS_GROUPS
  };
};

export const reportingProgressSetMetricAndKpi = data => {
  return {
    data,
    type: REPORTING_PROGRESS_SET_METRIC_AND_KPI
  };
};

export const reportingProgressSetGraphConfig = data => {
  return {
    data,
    type: REPORTING_PROGRESS_SET_GRAPH_CONFIG
  };
};

export const reportingSetCartography = cartography => {
  return {
    data: {
      cartography
    },
    type: REPORTING_SET_CARTOGRAPHY
  };
};

export const reportingSetCartographyMapConfig = cartographyMapConfig => {
  return {
    data: {
      cartographyMapConfig
    },
    type: REPORTING_SET_CARTOGRAPHY_MAP_CONFIG
  };
};

export const reportingSetCustomEvents = customEvents => {
  return {
    data: {
      customEvents
    },
    type: REPORTING_SET_CUSTOM_EVENTS
  };
};
